module.exports = __webpack_public_path__ + "static/lato-latin-400italic.22f9bdf3.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-400italic.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-400italic.woff
// module chunks = 17241999800008180000